var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 33C64.5 50.397 50.397 64.5 33 64.5C15.603 64.5 1.5 50.397 1.5 33C1.5 15.603 15.603 1.5 33 1.5C50.397 1.5 64.5 15.603 64.5 33Z",
    fill: "#FFFCF3",
    stroke: "#F0B323",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3987 19.8C36.3987 17.9775 34.9172 16.5 33.0897 16.5C31.2622 16.5 29.7808 17.9775 29.7808 19.8V39.6C29.7808 41.4225 31.2622 42.9 33.0897 42.9C34.9172 42.9 36.3987 41.4225 36.3987 39.6V19.8Z",
    fill: "#F0B323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3987 49.5002C36.3987 47.6777 34.9172 46.2002 33.0897 46.2002C31.2622 46.2002 29.7808 47.6777 29.7808 49.5002C29.7808 51.3227 31.2622 52.8002 33.0897 52.8002C34.9172 52.8002 36.3987 51.3227 36.3987 49.5002Z",
    fill: "#F0B323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationmark);
export default __webpack_public_path__ + "static/media/exclamationmark.9e9eba36b31303243923ce345ee6a10c.svg";
export { ForwardRef as ReactComponent };